<template>
  <div class="content">
    <el-form
      :model="staffForm"
      :rules="rules"
      ref="staffForm"
      label-width="82px"
      class="staff-form"
      label-position="left"
    >
      <!-- 手机号码 -->
      <el-form-item label="手机号码" prop="mobile" v-if="mobileShow">
        <el-input
          v-model="staffForm.mobile"
          :maxlength="11"
          placeholder="请输入"
          :disabled="mobileDisabled"
          style="width: 176px"
        ></el-input>
      </el-form-item>
      <!-- 登录名 -->
      <el-form-item label="登录名" prop="userName" v-if="type != 1">
        <el-input v-model="staffForm.userName" placeholder="请输入" :disabled="true" style="width: 176px"></el-input>
      </el-form-item>
      <!-- 姓名 -->
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="staffForm.name"
          :maxlength="20"
          placeholder="最多20个字符"
          :disabled="nameDisabled"
          style="width: 176px"
        ></el-input>
      </el-form-item>
      <!-- 角色 -->
      <el-form-item label="角色" prop="roleList" v-if="roleSelectShow">
        <el-select v-model="staffForm.roleList" placeholder="请选择角色" :disabled="roleDisabled">
          <el-option :label="value" :value="key" v-for="(value, key) in roleType" :key="key"></el-option>
        </el-select>
      </el-form-item>
      <!-- 门店下拉框开始 -->
      <el-form-item
        v-if="staffForm.roleList !== 'regional_head'"
        label="门店"
        :prop="staffForm.roleList === 'remote_trial_pharmacist' ? 'storeList' : 'storeId'"
      >
        <zy-select
          v-if="staffForm.roleList === 'remote_trial_pharmacist'"
          key="storeList"
          v-model="staffForm.storeList"
          placeholder="请选择（可输入门店名称搜索）"
          filterable
          remote
          multiple
          valueKey="id"
          :loading="loading"
          :remote-method="remoteMethod"
          :load-method="loadMore"
          :disabled="storeDisabled"
          style="width: 416px"
        >
          <zy-option v-for="(item, i) in storeList" :key="i" :label="item.label" :value="item.value"></zy-option>
        </zy-select>
        <zy-select
          v-else
          key="storeId"
          v-model="staffForm.storeId"
          placeholder="请选择（可输入门店名称搜索）"
          filterable
          remote
          valueKey="id"
          :loading="loading"
          :remote-method="remoteMethod"
          :load-method="loadMore"
          :disabled="storeDisabled"
          style="width: 416px"
        >
          <zy-option v-for="(item, i) in storeList" :key="i" :label="item.label" :value="item.value"></zy-option>
        </zy-select>
      </el-form-item>
      <el-form-item label="负责大区" prop="areaList" v-if="staffForm.roleList === 'regional_head'">
        <el-select multiple v-model="staffForm.areaList" placeholder="请选择" :disabled="statusDisabled">
          <el-option
            v-for="item in this.areaList"
            :key="item.id"
            :label="item.name"
            :disabled="areaShow(item.areaUserId, item.id)"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="大区门店" v-if="staffForm.roleList === 'regional_head'">
        <div class="stores-box">
          <p class="title">门店列表</p>
          <ul class="list">
            <li class="item" v-for="(storeName, i) in areaStoreList" :key="i">
              {{ storeName }}
            </li>
          </ul>
        </div>
      </el-form-item>
      <!-- 门店下拉框结束 -->
      <!-- 门店穿梭框开始 -->
      <!--      <el-form-item label="门店" prop="storeList" v-if="storeShow(1)">-->
      <!--        &lt;!&ndash; 添加和编辑的时候 &ndash;&gt;-->
      <!--        <zy-select-->
      <!--          v-if="type !== 2"-->
      <!--          v-model="staffForm.storeList"-->
      <!--          placeholder="请选择（可输入门店名称搜索）"-->
      <!--          valueKey="id"-->
      <!--          filterable-->
      <!--          remote-->
      <!--          multiple-->
      <!--          :loading="loading"-->
      <!--          :remote-method="remoteMethod"-->
      <!--          :load-method="loadMore"-->
      <!--          :disabled="storeDisabled"-->
      <!--          style="width: 416px"-->
      <!--        >-->
      <!--          <zy-option v-for="(item, i) in storeList" :key="i" :label="item.label" :value="item.value"></zy-option>-->
      <!--        </zy-select>-->
      <!--        &lt;!&ndash; 查看 &ndash;&gt;-->
      <!--        <div class="stores-box" v-else>-->
      <!--          <p class="title">门店列表</p>-->
      <!--          <ul class="list">-->
      <!--            <li class="item" v-for="item in staffInfo.storeList" :key="item.id">-->
      <!--              {{ item.name }}-->
      <!--            </li>-->
      <!--          </ul>-->
      <!--        </div>-->
      <!--      </el-form-item>-->
      <!-- 门店穿梭框结束 -->
      <!-- 状态 -->
      <el-form-item class="item-disabled" label="状态" prop="disableStatus">
        <el-radio-group v-model="staffForm.disableStatus">
          <el-radio :label="Number(key)" v-for="(value, key) in disableStatus" :key="key" :disabled="statusDisabled">
            {{ value }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="上下班打卡" prop="punchOn" v-if="staffForm.roleList === 'remote_trial_pharmacist'">
        <el-radio-group v-model="staffForm.punchOn">
          <el-radio :label="Number(key)" v-for="(value, key) in punchStatus" :key="key" :disabled="statusDisabled">
            {{ value }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="执业类别" prop="practiceCategory" v-if="staffForm.practiceCategory">
        <el-input :value="practiceCategoryName" disabled style="width: 176px"></el-input>
      </el-form-item>
      <div class="photo-wrapper" v-if="photoRender">
        <!-- 药师身份证 -->
        <el-form-item
          label="药师身份证"
          v-show="staffInfo.frontIdCard || staffInfo.backIdCard"
          class="id-card item-image"
        >
          <div class="upload-box">
            <img-upload ref="frontIdCard" :disabled="true" v-show="staffInfo.frontIdCard"></img-upload>
          </div>
          <div class="upload-box">
            <img-upload ref="backIdCard" :disabled="true" v-show="staffInfo.backIdCard"></img-upload>
          </div>
        </el-form-item>
        <!-- 药师注册证 -->
        <el-form-item label="药师注册证" class="item-image" v-show="staffInfo.pharmacistRegistration">
          <div class="upload-box">
            <img-upload ref="pharmacistRegistration" :disabled="true"></img-upload>
          </div>
        </el-form-item>
        <!-- 药师资格证 -->
        <el-form-item label="药师资格证" class="item-image" v-show="staffInfo.pharmacistQualification">
          <div class="upload-box">
            <img-upload ref="pharmacistQualification" :disabled="true"></img-upload>
          </div>
        </el-form-item>
      </div>

      <!-- 提交按钮 -->
      <el-form-item>
        <el-button type="primary" class="submit" @click="submitForm('staffForm')" v-if="clickable">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Fetch from '@/api/index';
import imgUpload from '@/components/shopManagement/upload';
import { getRoleType, hasRole } from '@/util';
import Constant from '@/lib/constant';
import zySelect from '@/components/select/src/select';
import zyOption from '@/components/select/src/option';
const baseRole = Constant.RoleList;

const roleTypeName = Constant.roleType;
const practiceCategoryMap = {
  PHARMACY: '药学',
  CHINESE_PHARMACY: '中药学',
  PHARMACY_AND_CHINESE: '药学与中药',
  1: '药学',
  2: '中药学',
  3: '药学与中药'
};
const TYPE = {
  // 店长下拉
  store_manager: {
    clerk: '店员',
    pharmacist: '药师'
  },
  // 大区负责人
  area_manager: {
    store_manager: '店长',
    clerk: '店员',
    pharmacist: '药师',
    store_manager_and_pharmacist: '店长兼药师',
    regional_head: '大区负责人'
  },
  // 非连锁公司负责人
  company_representative: {
    store_manager: '店长',
    clerk: '店员',
    pharmacist: '药师',
    store_manager_and_pharmacist: '店长兼药师',
    remote_trial_pharmacist: '远程审方药师'
  },
  // 连锁公司负责人
  company_representative_area: {
    store_manager: '店长',
    clerk: '店员',
    pharmacist: '药师',
    store_manager_and_pharmacist: '店长兼药师',
    remote_trial_pharmacist: '远程审方药师',
    regional_head: '大区负责人'
  },
  // 店长兼商城管理员下拉
  store_manager_and_buyers: {
    clerk_and_buyers: '店员兼商城管理员',
    pharmacist_and_buyers: '药师兼商城管理员'
  },
  // (区域)公司负责人兼商城管理员
  area_manage_and_buyers: {
    store_manager_and_buyers: '店长兼商城管理员',
    clerk_and_buyers: '店员兼商城管理员',
    pharmacist_and_buyers: '药师兼商城管理员',
    store_manager_and_pharmacist_and_buyers: '店长兼药师兼商城管理员'
  }
};
let editSelectedArea = [];
const handleStoreList = (storeList, selectedStores) => {
  console.log(storeList, selectedStores);
  return Array.from(new Set([...selectedStores, ...storeList].filter(Boolean).map(store => JSON.stringify(store)))).map(
    o => {
      const store = JSON.parse(o);
      return { label: store.name, value: store };
    }
  );
};

export default {
  props: {
    // type == 1为添加职员,type == 2为查看职员,type == 3为编辑职员
    type: {
      default: ''
    }
  },
  components: { imgUpload, zySelect, zyOption },
  async mounted() {
    // 编辑和查看的时候获取职员信息
    // 下拉框赋值不同,角色下拉框展示的值不同
    if (!hasRole(this.currentRoleType, 'a')) {
      if (hasRole(this.currentRoleType, 'c')) {
        if (this.type == 2) {
          this.roleType = TYPE.company_representative_area;
        } else {
          // 区域负责人新增和编辑 不能新增区域负责人
          this.roleType = Object.keys(TYPE.area_manager)
            .filter(k => k != 'regional_head')
            .reduce((obj, k) => {
              return { ...obj, [k]: TYPE.area_manager[k] };
            }, {});
        }
      } else {
        if (this.type == 2) {
          this.roleType = TYPE.company_representative_area;
        } else {
          this.roleType = TYPE.store_manager;
        }
      }
    } else {
      if (this.$store.getters.isChain == '1') {
        this.roleType = TYPE.company_representative_area;
      } else {
        this.roleType = TYPE.company_representative;
      }
    }

    if (this.type == 3 || this.type == 2) {
      if (this.$checkPower('a,c')) {
        await this.getAreaList().then(_ => this.getUser());
      } else {
        await this.getUser();
      }
    } else {
      this.$checkPower('a,c') && (await this.getAreaList());
    }
    // 获取门店列表
    await this.getStoreList({ storeName: '', status: 1, isDelete: 0, disableStatus: 0 });
  },
  computed: {
    currentRoleType() {
      return this.$store.getters.roleType;
    },
    userId() {
      return this.$store.getters.userId;
    },
    // 用来控制提交按钮的展示
    clickable() {
      // 查看的时候不展示，添加和编辑的时候展示
      return this.type != 2;
    },
    // 门店选择模式
    storeSelectMode() {
      // 当添加远程审方药师的时候，穿梭框选择
      if (this.staffForm.roleList == baseRole.b) {
        return 1;
      } else {
        // 其他情况，可搜索下拉框选择
        return 2;
      }
    },
    // 姓名禁用 1.9.3版本公司负责人可以修改姓名和手机号
    nameDisabled() {
      // 查看的时候不可编辑
      if (this.type == 2) {
        return true;
      }
      // 编辑的时候，公司负责人编辑公司负责人信息的时候，姓名不可编辑
      if (this.type == 3) {
        // 操作者是公司负责人
        // 智云专配远程药师，除门店以为其他信息不可编辑
        if (this.staffInfo.isPlatformPharmacist) {
          return true;
        }
      }
      return false;
    },
    // 电话禁用
    mobileDisabled() {
      // 添加的时候，电话号码是可编辑的
      if (this.type == 1) {
        return false;
      }

      // 可编辑
      if (this.type == 3) {
        // 公司负责人和店长可以不可以编辑智云专配远程药师
        if (hasRole(this.currentRoleType, 'a') || hasRole(this.currentRoleType, 'd')) {
          return this.staffInfo.isPlatformPharmacist;
        }
      }
      return true;
    },
    // 门店禁用
    storeDisabled() {
      // 当不包含公司负责人角色的时候，即又店长的时候，添加和编辑的时候，门店默认为店长所属门店不可编辑
      if (!hasRole(this.currentRoleType, 'a') && !hasRole(this.currentRoleType, 'c')) {
        return true;
      }
      // 当查看的时候不可编辑
      return this.type == 2;
    },
    // 状态选择禁用
    statusDisabled() {
      // 查看的时候不可编辑
      if (this.type == 2) {
        return true;
      }
      // 编辑的时候，公司负责人编辑公司负责人信息的时候，状态不可编辑
      if (this.type == 3) {
        // 操作者是公司负责人
        // 根据现有业务逻辑来规避，后续有别的人员可以编辑公司负责人的时候再更改
        // 被编辑者是公司负责人，只有公司负责人才能编辑公司负责人，所以只需要判断被编辑这是公司负责人的话，那肯定是被公司负责人编辑
        if (hasRole(this.targetRoleType, 'a')) {
          return true;
        }
        // 智云专配远程药师，除门店以为其他信息不可编辑
        if (this.staffInfo.isPlatformPharmacist) {
          return true;
        }
      }
      return false;
    },
    // 角色禁用状态
    roleDisabled() {
      let { type, staffInfo } = this;
      // 查看的时候，不可编辑角色
      if (type == 2) {
        return true;
      }
      // 编辑的时候
      if (type == 3) {
        // 智云专配远程药师，除门店以为其他信息不可编辑
        if (staffInfo.isPlatformPharmacist) {
          return true;
        }
      }
      return false;
    },
    // 角色选择框的展示
    roleSelectShow() {
      // 如果是仅是公司负责人查看自己的信息的时候，不用展示角色和门店
      if (this.type == 2) {
        if (hasRole(this.targetRoleType, 'a', 1)) {
          return false;
        }
      }
      return true;
    },
    // 只有查看编辑的时候显示药师资格证，只读
    photoRender() {
      let { type } = this;
      if (type == 2) {
        return true;
      }
      return type == 3;
    },
    // 电话号码显示
    mobileShow() {
      let { type } = this;
      // 查看，不存在手机号不显示手机号
      if (type == 2) {
        if (!this.staffForm.mobile) {
          return false;
        }
      }
      return true;
    },
    practiceCategoryName() {
      return practiceCategoryMap[this.staffForm.practiceCategory] || '';
    }
  },
  watch: {
    'staffForm.areaList': {
      handler(val) {
        this.areaStoreList = this.areaList
          .filter(area => val.includes(area.id))
          .reduce((storeList, store) => {
            return storeList.concat(store.storeNameList);
          }, []);
      },
      deep: true
    },
    'staffForm.roleList'(val) {
      if (val !== 'regional_head') {
        if (val !== 'remote_trial_pharmacist') {
          handleStoreList(
            this.storeList.map(o => o.value),
            [this.staffForm.storeId]
          );
        } else {
          handleStoreList(
            this.storeList.map(o => o.value),
            this.staffForm.storeList
          );
        }
      }
    }
  },
  data() {
    return {
      roleType: TYPE.company_representative, // 角色选择框值
      disableStatus: Constant.disableStatus, // 状态选择值
      punchStatus: Constant.punchStatus, // 上下班打卡选择值
      staffForm: {
        // 表单数据
        name: '',
        mobile: null,
        disableStatus: 0,
        storeId: null, // 下拉框门店选择绑定值
        storeList: [], // 穿梭框门店选择绑定值
        roleList: '', // 角色选择绑定值
        userName: '',
        punchOn: 0,
        practiceCategory: '',
        areaList: []
      },
      rules: {
        // 表单验证规则
        name: [
          { required: true, message: '请填写正确姓名', trigger: 'blur' },
          { max: 20, message: '姓名最多支持20个字', trigger: 'blur' },
          // 只能输入中文和数字
          {
            message: '姓名填写不规范，请检查',
            validator: (rule, value, callback) => {
              if (/^[\u4e00-\u9fa5][\u4e00-\u9fa5·]{0,18}?[\u4e00-\u9fa5]$/.test(value) && !/·{2,}/.test(value)) {
                callback();
              } else {
                callback(Error('姓名填写不规范，请检查'));
              }
            },
            trigger: 'blur'
          }
        ],
        mobile: [
          // { required: true, message: '请输入正确手机号', trigger: 'blur' },
          { max: 11, message: '请输入正确手机号', trigger: 'blur' },
          {
            message: '请输入正确手机号',
            pattern: /^1[23456789]\d{9}$/,
            trigger: 'blur'
          }
        ],
        userName: [{ required: true, message: '请填写正确姓名', trigger: 'blur' }],
        roleList: [{ required: true, message: '请选择', trigger: 'change' }],
        storeId: [{ required: true, message: '请选择', trigger: 'change' }],
        disableStatus: [{ required: true, message: '请选择', trigger: 'change' }],
        storeList: [
          {
            type: 'array',
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ],
        areaList: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      transferDatas: [], // 穿梭框需要的数据
      storeList: [], // 获取门店列表
      staffInfo: {}, // 职员信息
      targetRoleType: '', // 目标角色的类型
      areaList: [],
      areaStoreList: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
        hasNext: true
      },
      loading: false
    };
  },
  methods: {
    checkBuyers() {
      // 商城管理员角色区分
      if (hasRole(this.targetRoleType, 'l')) {
        if (
          this.type == 3 &&
          !hasRole(this.currentRoleType, 'a') &&
          !hasRole(this.currentRoleType, 'c') &&
          hasRole(this.currentRoleType, 'd')
        ) {
          this.roleType = TYPE.store_manager_and_buyers;
        } else {
          this.roleType = TYPE.area_manage_and_buyers;
        }
      }
    },
    checkO2O() {
      // 如果是编辑角色
      // 如果编辑对象包含快药管理员权限
      // 则下拉框中，店员和店长的角色需要添加 ”兼快药管理员“
      if (this.type == '3' && hasRole(this.targetRoleType, 'm')) {
        const roleType = {};
        Object.keys(this.roleType).forEach(key => {
          if (key.indexOf(baseRole.d) != -1 || key.indexOf(baseRole.e) != -1) {
            roleType[`${key}_and_${baseRole.m}`] = `${this.roleType[key]}兼${roleTypeName[baseRole.m]}`;
          } else {
            roleType[key] = this.roleType[key];
          }
        });
        this.roleType = roleType;
      }
    },
    storeShow(storeMode) {
      // 非大区负责人
      if (this.staffForm.roleList !== 'regional_head') {
        // 当查看的只担任公司负责人角色的时候，门店不显示
        if (this.type == 2 && hasRole(this.targetRoleType, 'a', 1)) {
          return false;
        } else {
          // 其他时候，门店选择模式是2的时候展示
          if (this.storeSelectMode == storeMode) {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    },
    // 提交form表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        // 当通过验证的时候
        if (valid) {
          let data = Object.assign({}, this.staffForm);
          data.storeList = [];
          // 角色数据处理
          data.roleList = this.getRoleArr(this.staffForm.roleList);
          // 店铺数据处理
          if (this.staffForm.roleList !== 'regional_head') {
            if (this.storeSelectMode == 1) {
              data.storeList = this.staffForm.storeList.map(o => o.id);
            } else {
              data.storeList = [this.staffForm.storeId.id];
            }
          }

          // 删除接口需要数据
          delete data.storeId;

          // 添加
          let self = this;
          if (this.type == 1) {
            Util.submitOnce(function () {
              self.addUser(data);
            });
            // 编辑
          } else if (this.type == 3) {
            Util.submitOnce(function () {
              self.updateUser(data);
            });
          }
        } else {
          return false;
        }
      });
    },
    // 处理角色，给后端
    // 前端兼任角色是把后端的角色通过'_and_'连接起来的
    getRoleArr(roleList) {
      let roleArr = [];
      if (roleList.indexOf('_and_') > -1) {
        roleArr = roleList.split('_and_');
      } else {
        roleArr.push(this.staffForm.roleList);
      }
      return roleArr;
    },
    // 添加职员
    addUser(data) {
      Fetch.addUser(data).then(res => {
        if (res) {
          this.$message('职员添加成功');
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        }
      });
    },
    // 编辑职员
    updateUser(data) {
      data.id = this.staffInfo.id;
      Fetch.updateUser(data).then(res => {
        if (res) {
          this.$message('职员编辑成功');
          setTimeout(() => {
            // 如果自己编辑自己的时候，页面跳转并刷新，后端会塞个新token，不会被登出
            if (this.userId == data.id) {
              this.$router.replace('/staffManagement');
              location.reload();
            } else {
              this.$router.replace('/staffManagement');
            }
          }, 1500);
        }
      });
    },
    getAreaList() {
      return Fetch.queryAreaList({
        companyId: this.$store.getters.companyId,
        pageNo: 1,
        pageSize: 1000,
        needStore: 1
      }).then(({ data }) => {
        this.areaList = data;
      });
    },
    // 获取职员信息
    async getUser(id) {
      const staffId = this.$route.params.staffId;
      let res = await Fetch.getUserDetail({ id: staffId });
      this.staffInfo = { ...res };
      let { name, mobile, roleList, disableStatus, storeList, userName, punchOn, practiceCategory, areaList } = res;

      if (storeList instanceof Array) {
        // 店铺被禁用，不解绑店铺人员，后端返回的用户详情接口中的storeList还是用存在被禁用的药店，isDelete为1，所以我们自己过滤下
        storeList = storeList.filter(item => {
          return item.isDelete == 0;
        });
        this.staffInfo.storeList = storeList;
      }

      // 获取目标角色类型
      const roleType = getRoleType(roleList);
      // 按字母顺序排序，以保证所有的角色都是以字母表顺序排列，和下拉框的key构造规则对应
      this.targetRoleType = roleType
        .split('_')
        .sort((a, b) => a.charCodeAt(0) - b.charCodeAt(0))
        .join('_');
      this.checkBuyers();
      this.checkO2O();
      // 处理角色列表
      let staffForm = {
        name,
        mobile,
        roleList,
        disableStatus,
        storeList,
        userName,
        punchOn,
        practiceCategory,
        areaList: areaList.map(area => area.id)
      };
      editSelectedArea = areaList.map(area => area.id);
      staffForm.roleList = this.roleSelectType(this.targetRoleType);
      this.staffForm = staffForm;
      // 当编辑和查看的时候，初始化选择框数据
      if (this.type == 3 || this.type == 2) {
        // 当只是公司负责人的时候，没有storeList,如果有用户所以的店铺都被禁用，storeList为空
        if (this.staffInfo.storeList && this.staffInfo.storeList.length > 0) {
          this.initSelectStoreData();
        }
      }
      // 初始化药师资格证照片
      this.initPhoto();
    },
    initPhoto() {
      let { frontIdCard, backIdCard, pharmacistRegistration, pharmacistQualification } = this.staffInfo;
      if (frontIdCard) this.$refs.frontIdCard.setImg(frontIdCard);
      if (backIdCard) this.$refs.backIdCard.setImg(backIdCard);
      if (pharmacistRegistration) this.$refs.pharmacistRegistration.setImg(pharmacistRegistration);
      if (pharmacistQualification) this.$refs.pharmacistQualification.setImg(pharmacistQualification);
    },
    // 获取门店列表
    async getStoreList() {
      // 如果不具有公司负责人角色，目前就是店长，门店自动选择它属于的店
      if (!hasRole(this.currentRoleType, 'a') && !hasRole(this.currentRoleType, 'c')) {
        const store = this.$store.getters.storeList[0];
        this.staffForm = { ...this.staffForm, storeId: { id: store.id, name: store.name } };
        this.storeList = [{ label: store.name, value: store }];
      } else {
        const { pageSize } = this.page;
        const result = await Fetch.queryStorePage({ pageNo: 1, pageSize });
        this.storeList =
          this.storeSelectMode === 1
            ? handleStoreList(result.data, this.staffForm.storeList)
            : handleStoreList(result.data, [this.staffForm.storeId]);
        this.page.pageNo = result.pageNo;
        this.page.total = result.total;
        this.page.hasNext = result.hasNextPage;
      }
    },
    initSelectStoreData() {
      if (this.storeSelectMode == 1) {
        // 编辑的时候
        // 处理门店列表
        this.staffForm.storeList = this.staffForm.storeList.map(store => ({ id: store.id, name: store.name }));
      } else {
        // 选择框需要的数据格式
        // 因为直接给属性赋值，存在赋初始值的时候，值更改，ui不更新
        const store = this.staffForm.storeList[0];

        this.staffForm = {
          ...this.staffForm,
          storeId: { id: store.id, name: store.name },
          storeList: []
        };
      }
    },
    // 角色选择框需要的role
    roleSelectType(roleType) {
      // 被编辑者具有兼任身份
      let roleTypeArr = roleType.split('_');
      if (roleTypeArr.length > 1) {
        if (roleType.indexOf('m') > -1) {
          return roleTypeArr.map(role => baseRole[role]).join('_and_');
        } else if (roleType.indexOf('d') > -1 && roleType.indexOf('f') > -1 && roleType.indexOf('l') > -1) {
          // 如果是店长兼药师或者公司负责人兼店长兼药师
          return `${baseRole.d}_and_${baseRole.f}_and_${baseRole.l}`;
        } else if (roleType.indexOf('l') > -1) {
          const otherType = roleTypeArr.find(item => item !== 'a' && item !== 'c' && item !== 'l');
          return `${baseRole[otherType]}_and_${baseRole.l}`;
        } else if (roleType.indexOf('d') > -1 && roleType.indexOf('f') > -1) {
          return `${baseRole.d}_and_${baseRole.f}`;
        } else {
          // 如果公司负责人兼任其他角色，只显示其他角色，根据业务逻辑公司负责人目前除了店长兼药师以外，只能兼任一个角色
          if (roleType.indexOf('a') > -1) {
            let index = roleTypeArr.findIndex((value, index, arr) => {
              return value != 'a';
            });
            return baseRole[roleTypeArr[index]];
          }
        }
      } else if (roleTypeArr.length == 1) {
        // 如果是公司负责人选择角色框为空
        if (roleType.indexOf('a') > -1) {
          return '';
        } else {
          return baseRole[roleType];
        }
      }
    },
    areaShow(areaUserId, areaId) {
      if (this.type == 1) {
        return !!areaUserId;
      }

      if (this.type == 3) {
        return editSelectedArea.includes(areaId) ? false : !!areaUserId;
      }
    },
    async remoteMethod(val) {
      const { pageSize } = this.page;
      this.loading = true;
      const result = await Fetch.queryStorePage({ storeName: val, pageNo: 1, pageSize });
      this.loading = false;

      this.storeList =
        this.storeSelectMode === 1
          ? handleStoreList(result.data, this.staffForm.storeList)
          : handleStoreList(result.data, [this.staffForm.storeId]);

      this.page.pageNo = result.pageNo;
      this.page.total = result.total;
      this.page.hasNext = result.hasNextPage;
    },
    async loadMore(val) {
      const { hasNext, pageNo, pageSize } = this.page;

      if (hasNext) {
        const result = await Fetch.queryStorePage({ storeName: val, pageNo: pageNo + 1, pageSize });

        this.storeList = this.storeList.concat(...result.data?.map(o => ({ label: o.name, value: o })));
        this.page.pageNo = result.pageNo;
        this.page.total = result.total;
        this.page.hasNext = result.hasNextPage;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  background: #fff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  min-height: 618px;
  padding: 20px 16px;

  .item-disabled {
    margin-bottom: 10px;
  }

  .item-image {
    /deep/label {
      line-height: 23px;
    }
  }

  .staff-form {
    /deep/ .el-radio {
      display: inline-flex;
    }
    .stores-box {
      display: flex;
      flex-direction: column;
      width: 584px;
      height: 320px;
      overflow: hidden;
      // padding: 0 13px;
      background: #fafafa;
      font-size: 14px;
      color: #707070;
      border-radius: 4px;
      .title {
        height: 39px;
        padding: 0 13px;
        border-bottom: 1px solid #f2f2f2;
      }
      .list {
        flex: 1;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        padding: 0 13px;
        .item {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #242424;
        }
      }
    }
    .photo-wrapper {
      .id-card {
        .upload-box {
          display: inline-block;
          margin-right: 16px;
        }
      }
    }
    .submit {
      &.el-button--primary {
        width: 174px;
        height: 40px;
        background: #1e8dff;
        border-radius: 4px;
        border: 1px solid #1e8dff;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .d-transfer {
    /deep/ .el-transfer-panel__body {
      display: flex;
      flex-direction: column;
      .el-transfer-panel__list {
        flex: 1;
      }
    }
    /deep/ .el-transfer-panel__item.el-checkbox .el-checkbox__label {
      overflow: unset;
    }
  }
}
</style>
